module.exports = __webpack_public_path__ + "img/logo_aboutus.5d69cd19.png";